import {TrackingService} from "./tracking_service";
import {CinemaChangeEvent, CinemaInitializedEvent, TrackingFeatureLabels} from "../types";
import Tile from "./tile";

export default class ShopPromoSmall {
    private readonly featureOrder: number;
    private readonly masFeatureTrackingLabels: TrackingFeatureLabels
    private readonly personalizationContext: string;
    private readonly featureIndex: number;
    readonly tiles: Tile[];
    private trackingService: TrackingService;

    constructor(shopPromoSmallDom: Element) {
        this.featureIndex = this.getFeatureIndex(shopPromoSmallDom);
        this.masFeatureTrackingLabels = this.getMasFeatureTrackingLabels(shopPromoSmallDom);
        this.featureOrder = this.getFeatureOrder(shopPromoSmallDom);
        this.personalizationContext = this.getPersonalizationContext(shopPromoSmallDom);
        this.trackingService = new TrackingService();
        this.tiles = Array.from(shopPromoSmallDom.querySelectorAll(".pl_promo-card--link")).map((tileDom) => new Tile(tileDom as HTMLElement));

        this.tiles.forEach((tile) => {
            tile.tileDom.addEventListener("click", () => this.trackClickSmallShopPromo(tile))
        })

        /*🤫*/
        const cinemaDom = shopPromoSmallDom.querySelector(".promo_shoppromo-small--cinema");
        cinemaDom?.setAttribute("data-feature-index", this.featureIndex.toString());

        window.o_global.eventQBus.on("pattern.carousel.mounted", (e) => {
            this.trackInitialLoadedSmallShopPromo(e)
            this.registerVisibleTrackObserver(e);
        });
        window.o_global.eventQBus.on("pattern.carousel.stage.changed", (e) => {
            this.trackPreviousSlideSmallShopPromo(e)
        });

        window.o_global.eventQBus.emit(
            "pattern.carousel.init",
            `.promo_shoppromo-small--container[data-feature-index="${this.featureIndex}"] .js_pl_carousel`
        )

    }

    trackedTilePositions: number[] = []

    registerVisibleTrackObserver(e: CinemaInitializedEvent): void {
        const eventFeatureIndex = this.getFeatureIndex(e.element);
        if (e.element.className.includes("promo_shoppromo-small--cinema") && eventFeatureIndex == this.featureIndex) {
            /*🤫*/
            const observer = new IntersectionObserver((entries) => {
                const tilesToTrack = entries
                    .filter((entry) => entry.isIntersecting)
                    .map((entry) => new Tile(entry.target as HTMLElement));

                if (tilesToTrack.length > 0) {
                    const action = this.determineAction(tilesToTrack[0]);
                    this.trackedTilePositions.push(...tilesToTrack.map(tile => tile.position));
                    if (action == "scroll") {
                        this.trackingService.sendMiniAction(this.featureIndex, tilesToTrack, action);
                    } else {
                        this.trackingService.sendSmallShoppromoSlideTrackingEvent(this.featureOrder, this.featureIndex, this.personalizationContext, this.tiles.length, tilesToTrack, action, this.masFeatureTrackingLabels);
                    }
                }
                tilesToTrack.forEach(tile => observer.unobserve(tile.tileDom));
            }, {});

            this.tiles.forEach((tile) => {
                observer.observe(tile.tileDom);
            })
        }
    }

    private determineAction(tile: Tile): "scroll" | "next" | "previous" {
        /*🤫*/
        if (tile.position % 2 != 0 && this.trackedTilePositions.some(position => position % 2 != 0)) {
            return "next";
        }

        /*🤫*/
        if (tile.position % 2 == 0 && this.trackedTilePositions.some(position => position % 2 == 0)) {
            /*🤫*/
            if (this.trackedTilePositions.some(position => position % 2 == 0 && position < tile.position)) {
                return "next";
            } else {
                return "previous";
            }
        }

        /*🤫*/
        return "scroll";
    }

    trackInitialLoadedSmallShopPromo(e: CinemaInitializedEvent): void {
        const eventFeatureIndex = this.getFeatureIndex(e.element);
        if (e.element.className.includes("promo_shoppromo-small--cinema") && eventFeatureIndex == this.featureIndex && !e.element.parentElement?.getAttribute("data-tracked")) {
            e.element.parentElement?.setAttribute("data-tracked", String(true));
            this.trackingService.sendSmallShoppromoInitialLoadedTrackingEvent(this.featureOrder, this.featureIndex, this.personalizationContext, this.tiles.length, this.tiles, this.masFeatureTrackingLabels);
        }
    }

    trackPreviousSlideSmallShopPromo(e: CinemaChangeEvent): void {
        const eventFeatureIndex = this.getFeatureIndex(e.element);
        if (e.element.className.includes("promo_shoppromo-small--cinema") && !e.scrollingRight && eventFeatureIndex == this.featureIndex) {
            this.trackingService.sendSmallShoppromoSlideTrackingEvent(this.featureOrder, this.featureIndex, this.personalizationContext, this.tiles.length, [], "previous", this.masFeatureTrackingLabels);
        }
    }

    trackClickSmallShopPromo(tile: Tile): void {
        this.trackingService.sendSmallShoppromoClickTrackingEvent(this.featureOrder, this.featureIndex, this.personalizationContext, this.tiles.length, tile, this.masFeatureTrackingLabels);
    }

    private getVisibleTiles(tiles: Array<Tile>, currentSlides: number[]) {
        const tilesPerSlide = 2;
        const start = currentSlides[0] * tilesPerSlide;
        const end = (currentSlides[currentSlides.length - 1] + 1) * tilesPerSlide;
        return tiles.slice(start, end);
    }

    private getFeatureOrder(container: Element): number {
        const dataFeatureOrder = container.closest('[data-feature-order]')?.getAttribute('data-feature-order');
        return dataFeatureOrder ? parseInt(dataFeatureOrder, 0) : -1;
    }

    private getMasFeatureTrackingLabels(container: Element): TrackingFeatureLabels {
        const dataFeatureTrackingLabels = container.closest('[data-feature-order]')?.getAttribute('data-feature-tracking-labels');
        return dataFeatureTrackingLabels ? JSON.parse(dataFeatureTrackingLabels) : {};
    }

    private getFeatureIndex(htmlElement: Element): number {
        return parseInt(htmlElement.getAttribute('data-feature-index')!, 0);
    }

    private getPersonalizationContext(shopPromoSmallDom: Element): string {
        return shopPromoSmallDom.getAttribute('data-context')!;
    }
}